export const AuthConstants = {
    CAS_NAMESPACE: 'ca.hrblock.cas',
    //temporary config setup for student myblock iteration 1 release on 15th Aug, 2023
    TA_DEV: 'https://ta-azure-devta-01.hrblock-dev.ca',
    TA_QA: 'https://ta-azure-qata-02.hrblock-qas.ca',
    TA: 'https://ta.hrblock-ta.ca'
};
